<script setup lang="ts">
import { useClipboard, useTimeoutFn } from '@vueuse/core'

interface Props {
  title: string | null
  urlPath: string
}

const props = withDefaults(defineProps<Props>(), {
  title: 'title here',
})

const emit = defineEmits(['closeShare'])
const el = ref<HTMLElement | null>(null)
const body = process.client && document.getElementsByTagName('body')[0]
el.value = body
const { copy } = useClipboard()
const copiedUrl = `${encodeURI(`${useSetSubdomain(useGetSubdomain())}${props.urlPath}`)}?utm_source=copy_link&utm_medium=referral&utm_campaign=social_sharing`
const { isPending, start } = useTimeoutFn(() => {}, 3000, { immediate: false })

function onShareLinkedin() {
  window.open(`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=linkedin&utm_medium=referral&utm_campaign=social_sharing')}`, '_blank')
}

function onShareTwitter() {
  window.open(`https://twitter.com/share?url=${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=twitter&utm_medium=referral&utm_campaign=social_sharing')}&text=${props.title || props.title}`, '_blank')
}

function onShareWA() {
  window.open(`https://api.whatsapp.com/send?text=${encodeURIComponent(props.title || props.title)} ${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=whatsapp&utm_medium=referral&utm_campaign=social_sharing')}`, '_blank')
}

function onShareTelegram() {
  window.open(`https://t.me/share/url?url=${encodeURI(`${window.location.origin}${props.urlPath}`)}${encodeURIComponent('?utm_source=telegram&utm_medium=referral&utm_campaign=social_sharing')}`, '_blank')
}
</script>

<template>
  <div class="bg-white rounded-xl p-6 pb-10">
    <p class="text-lg font-bold mb-6">
      Share this article
    </p>
    <div class="grid grid-cols-5">
      <div class="flex-none">
        <img class="w-10 h-10 cursor-pointer" src="/images/career-guide/Linkedin.png" @click="onShareLinkedin()">
      </div>
      <div class="flex-none">
        <img class="w-10 h-10 cursor-pointer" src="/images/career-guide/Twitter.png" @click="onShareTwitter()">
      </div>
      <div class="flex-none">
        <img class="w-10 h-10 cursor-pointer" src="/images/career-guide/Whatsapp.png" @click="onShareWA()">
      </div>
      <div class="flex-none">
        <img class="w-10 h-10 cursor-pointer" src="/images/career-guide/Telegram.png" @click="onShareTelegram()">
      </div>
      <div class="flex-none relative">
        <span v-if="isPending" class="text-xs border border-indigo-500 rounded-sm bg-indigo-50 p-2 absolute w-[80px] right-0 -top-12">Link Copied</span>
        <img class="w-10 h-10 cursor-pointer" src="/images/career-guide/Copy.png" @click="(copy(copiedUrl), start())">
      </div>
    </div>
  </div>
</template>

<style scoped>
.w-fit {
  width: fit-content;
}
body{
  overflow: scroll;
}
</style>
